import { waitForOfflineInstall } from './offline-install';

let registration: Promise<ServiceWorkerRegistration> | undefined;

export async function registerShellBuild(script: string): Promise<ServiceWorkerRegistration> {
  await waitForOfflineInstall();
  return navigator.serviceWorker.register(`/sw.js?build=${encodeURIComponent(script)}`, { scope: '/', updateViaCache: 'none' });
}

/** One classic worker/root scope shared by the update UI and all signed-in infrastructure. */
export function shellWorkerRegistration(): Promise<ServiceWorkerRegistration> | undefined {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return undefined;
  const script = document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.getAttribute('src') ?? '/';
  return registration ??= (async () => {
    const existing = await navigator.serviceWorker.getRegistration('/');
    // Installed Push/offline support must remain usable even when new warming is paused.
    if (existing && [existing.active, existing.waiting, existing.installing].some(worker => {
      if (!worker) return false;
      const url = new URL(worker.scriptURL);
      return url.pathname === '/sw.js' && url.searchParams.get('build') === script;
    })) return existing;
    return registerShellBuild(script);
  })().catch(error => { registration = undefined; throw error; });
}

/** controllerchange may fire before the controlling worker reaches its activated state. */
export function applyShellUpdate(worker: Pick<ServiceWorker, 'state' | 'postMessage'>, controller: Pick<ServiceWorker, 'state' | 'postMessage'> | null, reload: () => void) {
  if (worker === controller || worker.state === 'activated') reload();
  else worker.postMessage({ type: 'HYLO_ACTIVATE_UPDATE' });
}
